import Vue from 'vue'
import VueI18n from 'vue-i18n'
import router from './routes'
import App from './App.vue'
import animated from 'animate.css'
import 'ant-design-vue/dist/antd.css'

import {
  Menu,
  Icon
} from 'ant-design-vue'
Vue.component(Menu.name, Menu)
Vue.component(Icon.name, Icon)

Vue.use(VueI18n)
Vue.use(Menu, Icon)

const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': require('./common/lang/zh'),
    'en-US': require('./common/lang/en')
  },
  silentTranslationWarn: true
})

new Vue({
  render: h => h(App),
  i18n,
  router
}).$mount('#app')